/**
 * @generated SignedSource<<4855e4c5ff2a3a0d1e202904ca9646fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type APPROVAL_STATUS = "APPROVED" | "SUBMITTED" | "NOT_SUBMITTED" | "PENDING" | "DECLINED" | "INVOICED" | "%future added value";
export type FILTER_SECTION = "PROJECT" | "SCOPING" | "SPRINT" | "SPRINT_BACKLOG" | "WORKFLOW" | "SCHEDULING_PEOPLE" | "SCHEDULING_PROJECTS" | "SCHEDULING_PLACEHOLDERS" | "SCHEDULING_CAPACITY_OVERVIEW" | "MY_TASKS" | "MY_LIST" | "MY_WORK" | "MY_TIMESHEETS" | "PROJECTS_OVERVIEW" | "INVOICING_OVERVIEW" | "INVOICING_INVOICES" | "FINANCIAL_PORTFOLIO_REPORT" | "TEAM_TIMESHEET" | "TIME_APPROVAL" | "REPORTED_TIME_TABLE" | "PROJECT_TIMELINE" | "UTILIZATION_REPORT" | "TASK_REPORT" | "SKILLS" | "LABELS" | "OPPORTUNITIES" | "%future added value";
export type LANGUAGE = "ENGLISH_US" | "ENGLISH_UK" | "ENGLISH_EU" | "SPANISH" | "DANISH" | "POLISH" | "FRENCH" | "%future added value";
export type TierType = "LITE" | "PRO" | "CORE" | "ENTERPRISE" | "TRIAL" | "FREE_FOREVER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type timesheetsTeamPage_viewer$data = {
  readonly component: string | null;
  readonly id: string;
  readonly harvestUser: boolean | null;
  readonly actualPersonId: string | null;
  readonly email: string | null;
  readonly backendId: number | null;
  readonly availableFeatureFlags: ReadonlyArray<{
    readonly key: string | null;
  } | null> | null;
  readonly filters: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly section: FILTER_SECTION | null;
        readonly value: string | null;
        readonly updatedAt: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly language: LANGUAGE | null;
  readonly projectOwner: boolean | null;
  readonly company: {
    readonly id: string;
    readonly bambooHREnabled: boolean | null;
    readonly characterLimit: number | null;
    readonly lockedPeriodYear: number | null;
    readonly lockedPeriodMonth: number | null;
    readonly lockedPeriodDay: number | null;
    readonly useTimeApproval: boolean | null;
    readonly useInternalTimeApproval: boolean | null;
    readonly useTimeOffApproval: boolean | null;
    readonly useTimeLocking: boolean | null;
    readonly sageIntacctConnectionEnabled: boolean | null;
    readonly sageIntacctTimeRegsFromForecast: boolean | null;
    readonly modules: ReadonlyArray<{
      readonly moduleType: string | null;
    } | null> | null;
    readonly tier: TierType | null;
    readonly idleTimes: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly isInternalTime: boolean | null;
        } | null;
      } | null> | null;
    } | null;
    readonly timeRegistrations: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly day: number | null;
          readonly month: number | null;
          readonly year: number | null;
          readonly minutesRegistered: number | null;
          readonly billableMinutesRegistered: number | null;
          readonly billable: boolean | null;
          readonly lockedInPeriod: boolean | null;
          readonly approvalStatus: APPROVAL_STATUS | null;
          readonly invoiced: boolean | null;
          readonly allocationId: string | null;
          readonly person: {
            readonly id: string;
            readonly startDate: string | null;
            readonly endDate: string | null;
            readonly monday: number | null;
            readonly tuesday: number | null;
            readonly wednesday: number | null;
            readonly thursday: number | null;
            readonly friday: number | null;
            readonly saturday: number | null;
            readonly sunday: number | null;
            readonly excludeFromCompanyLockedPeriod: boolean | null;
          } | null;
          readonly role: {
            readonly id: string;
            readonly name: string | null;
          } | null;
          readonly notes: string | null;
          readonly project: {
            readonly id: string;
            readonly name: string | null;
            readonly projectColor: string | null;
            readonly companyProjectId: number | null;
            readonly fullAccessToProject: boolean | null;
            readonly readOnlyAccess: boolean | null;
            readonly billable: boolean | null;
            readonly " $fragmentSpreads": FragmentRefs<"DeprecatedProjectIndicatorJS_project">;
          } | null;
          readonly task: {
            readonly id: string;
            readonly name: string | null;
            readonly companyTaskId: number | null;
            readonly billable: boolean | null;
            readonly estimateForecastMinutes: number | null;
            readonly totalMinutesRegistered: number | null;
            readonly project: {
              readonly id: string;
              readonly name: string | null;
              readonly companyProjectId: number | null;
              readonly customProjectId: string | null;
              readonly projectColor: string | null;
              readonly fullAccessToProject: boolean | null;
              readonly readOnlyAccess: boolean | null;
              readonly " $fragmentSpreads": FragmentRefs<"DeprecatedProjectIndicatorJS_project">;
            } | null;
          } | null;
          readonly idleTimeId: string | null;
          readonly idleTime: {
            readonly id: string;
            readonly name: string | null;
            readonly isInternalTime: boolean | null;
          } | null;
          readonly hiBobAllocationId: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly teams: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly teamPersons: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly person: {
                  readonly id: string;
                } | null;
              } | null;
            } | null> | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly allPersons: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly holidayCalendar: {
            readonly id: string;
            readonly holidayCalendarEntries: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly id: string;
                  readonly day: number | null;
                  readonly month: number | null;
                  readonly year: number | null;
                } | null;
              } | null> | null;
            } | null;
            readonly name: string | null;
          } | null;
          readonly id: string;
          readonly role: {
            readonly id: string;
            readonly name: string | null;
          } | null;
          readonly department: {
            readonly id: string;
            readonly name: string | null;
          } | null;
          readonly firstName: string | null;
          readonly lastName: string | null;
          readonly createdAt: string | null;
          readonly startDate: string | null;
          readonly endDate: string | null;
          readonly active: boolean | null;
          readonly monday: number | null;
          readonly tuesday: number | null;
          readonly wednesday: number | null;
          readonly thursday: number | null;
          readonly friday: number | null;
          readonly saturday: number | null;
          readonly sunday: number | null;
          readonly excludeFromCompanyLockedPeriod: boolean | null;
          readonly profilePictureId: string | null;
          readonly assignedProjectIds: ReadonlyArray<string | null> | null;
          readonly email: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "timesheetsTeamPage_viewer";
};
export type timesheetsTeamPage_viewer$key = {
  readonly " $data"?: timesheetsTeamPage_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"timesheetsTeamPage_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInternalTime",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "day",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "monday",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tuesday",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wednesday",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thursday",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "friday",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "saturday",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sunday",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "excludeFromCompanyLockedPeriod",
  "storageKey": null
},
v21 = [
  (v0/*: any*/),
  (v2/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v25 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "DeprecatedProjectIndicatorJS_project"
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullAccessToProject",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readOnlyAccess",
  "storageKey": null
},
v28 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000000
},
v29 = [
  (v28/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endDateString"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchQuery"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDateString"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "filters"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "company",
          "timeRegistrations"
        ]
      }
    ]
  },
  "name": "timesheetsTeamPage_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "team-timesheet-page"
        }
      ],
      "kind": "ScalarField",
      "name": "component",
      "storageKey": "component(name:\"team-timesheet-page\")"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "harvestUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backendId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeatureFlag",
      "kind": "LinkedField",
      "name": "availableFeatureFlags",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "filters",
      "args": null,
      "concreteType": "FilterTypeConnection",
      "kind": "LinkedField",
      "name": "__Viewer_filters_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FilterTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Filter",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "section",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedAt",
                  "storageKey": null
                },
                (v3/*: any*/)
              ],
              "storageKey": null
            },
            (v4/*: any*/)
          ],
          "storageKey": null
        },
        (v5/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bambooHREnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "characterLimit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockedPeriodYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockedPeriodMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockedPeriodDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTimeApproval",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useInternalTimeApproval",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTimeOffApproval",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTimeLocking",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sageIntacctConnectionEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sageIntacctTimeRegsFromForecast",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Module",
          "kind": "LinkedField",
          "name": "modules",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "moduleType",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IdleTimeTypeConnection",
          "kind": "LinkedField",
          "name": "idleTimes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IdleTimeTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IdleTime",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v6/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "timeRegistrations",
          "args": null,
          "concreteType": "TimeRegTypeConnection",
          "kind": "LinkedField",
          "name": "__Company_timeRegistrations_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeRegTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TimeRegType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v7/*: any*/),
                    (v8/*: any*/),
                    (v9/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minutesRegistered",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "billableMinutesRegistered",
                      "storageKey": null
                    },
                    (v10/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lockedInPeriod",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "approvalStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "invoiced",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "allocationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Person",
                      "kind": "LinkedField",
                      "name": "person",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v11/*: any*/),
                        (v12/*: any*/),
                        (v13/*: any*/),
                        (v14/*: any*/),
                        (v15/*: any*/),
                        (v16/*: any*/),
                        (v17/*: any*/),
                        (v18/*: any*/),
                        (v19/*: any*/),
                        (v20/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v22/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "notes",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProjectType",
                      "kind": "LinkedField",
                      "name": "project",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v2/*: any*/),
                        (v23/*: any*/),
                        (v24/*: any*/),
                        (v25/*: any*/),
                        (v26/*: any*/),
                        (v27/*: any*/),
                        (v10/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Task",
                      "kind": "LinkedField",
                      "name": "task",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v2/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "companyTaskId",
                          "storageKey": null
                        },
                        (v10/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "estimateForecastMinutes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "totalMinutesRegistered",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ProjectType",
                          "kind": "LinkedField",
                          "name": "project",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v2/*: any*/),
                            (v24/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "customProjectId",
                              "storageKey": null
                            },
                            (v25/*: any*/),
                            (v23/*: any*/),
                            (v26/*: any*/),
                            (v27/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "idleTimeId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IdleTime",
                      "kind": "LinkedField",
                      "name": "idleTime",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v2/*: any*/),
                        (v6/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hiBobAllocationId",
                      "storageKey": null
                    },
                    (v3/*: any*/)
                  ],
                  "storageKey": null
                },
                (v4/*: any*/)
              ],
              "storageKey": null
            },
            (v5/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v29/*: any*/),
          "concreteType": "TeamTypeConnection",
          "kind": "LinkedField",
          "name": "teams",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TeamTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Team",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v2/*: any*/),
                    {
                      "alias": null,
                      "args": (v29/*: any*/),
                      "concreteType": "TeamPersonTypeConnection",
                      "kind": "LinkedField",
                      "name": "teamPersons",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "TeamPersonTypeEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "TeamPerson",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Person",
                                  "kind": "LinkedField",
                                  "name": "person",
                                  "plural": false,
                                  "selections": [
                                    (v0/*: any*/)
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": "teamPersons(first:1000000)"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "teams(first:1000000)"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "excludeClientUsers",
              "value": true
            },
            (v28/*: any*/)
          ],
          "concreteType": "PersonTypeConnection",
          "kind": "LinkedField",
          "name": "allPersons",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PersonTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "HolidayCalendar",
                      "kind": "LinkedField",
                      "name": "holidayCalendar",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "endDate",
                              "variableName": "endDateString"
                            },
                            {
                              "kind": "Literal",
                              "name": "first",
                              "value": 100000
                            },
                            {
                              "kind": "Variable",
                              "name": "startDate",
                              "variableName": "startDateString"
                            }
                          ],
                          "concreteType": "HolidayCalendarEntryTypeConnection",
                          "kind": "LinkedField",
                          "name": "holidayCalendarEntries",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "HolidayCalendarEntryTypeEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "HolidayCalendarEntry",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    (v0/*: any*/),
                                    (v7/*: any*/),
                                    (v8/*: any*/),
                                    (v9/*: any*/)
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        (v2/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v0/*: any*/),
                    (v22/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DepartmentType",
                      "kind": "LinkedField",
                      "name": "department",
                      "plural": false,
                      "selections": (v21/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    (v11/*: any*/),
                    (v12/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "active",
                      "storageKey": null
                    },
                    (v13/*: any*/),
                    (v14/*: any*/),
                    (v15/*: any*/),
                    (v16/*: any*/),
                    (v17/*: any*/),
                    (v18/*: any*/),
                    (v19/*: any*/),
                    (v20/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "profilePictureId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "assignedProjectIds",
                      "storageKey": null
                    },
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "allPersons(excludeClientUsers:true,first:1000000)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "7c13e051730590a2fc97b989c9d8d8f4";

export default node;
